import { useCallback, useEffect, useState } from "react";

import { Lookups, ResourceName } from "./CatalogAdmin.types.tsx";
import { LOOKUP_PAGE_SIZE } from "./resources.tsx";

import { listRecords } from "../../services/catalog.services.tsx";

const LOOKUPS: ResourceName[] = [
  "systems",
  "refrigerants",
  "voltages",
  "technologies",
  "heat-exchangers",
  "efficiencies",
  "compressors",
];

export const useLookups = () => {
  const [lookups, setLookups] = useState<Lookups>({});

  const reloadLookups = useCallback(async () => {
    try {
      const pages = await Promise.all(
        LOOKUPS.map((resource) => listRecords(resource, "", 1, LOOKUP_PAGE_SIZE))
      );

      setLookups(
        Object.fromEntries(LOOKUPS.map((resource, index) => [resource, pages[index].items]))
      );
    } catch {
      setLookups({});
    }
  }, []);

  useEffect(() => {
    reloadLookups();
  }, [reloadLookups]);

  return { lookups, reloadLookups };
};
